import React, { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Input, Select, Hidden, DateTime } from '~/components/Form';


import { storeData, updateData } from '~/store/modules/atendimentoPosto/actions';

import { Spinner } from '~/components';
import { t } from '~/helpers';

import { Container } from './styles';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const optionsLBC = useMemo(
    () => [
      { value: 1, label: 'Liberado' },
      { value: 2, label: 'Bloqueado' },
      { value: 3, label: 'Cancelado' },
    ],
    []
  );

  const { loading, find, params } = useSelector((state) => state.atendimentoPosto);
  const initials = create ? data : { ...find, ...data };

  const handleSubmit = useCallback(
    async (param) => {
      try {
        const schema = Yup.object().shape({
          atpo_numero_os: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(50, t('s.geral.validacao.tamanhomaximo').replace('%s', 50))
          ,
          atpo_local_atendimento: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(50, t('s.geral.validacao.tamanhomaximo').replace('%s', 50))
          ,
          atpo_problema: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(500, t('s.geral.validacao.tamanhomaximo').replace('%s', 500))
          ,
          atpo_solucao: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(500, t('s.geral.validacao.tamanhomaximo').replace('%s', 500))
          ,
          atpo_tecnico: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(100, t('s.geral.validacao.tamanhomaximo').replace('%s', 100))
          ,
          atpo_equipamento: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(100, t('s.geral.validacao.tamanhomaximo').replace('%s', 100))
          ,
          atpo_causa: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(30, t('s.geral.validacao.tamanhomaximo').replace('%s', 30))
          ,
          atpo_numero_serie_entrada_abastek: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(50, t('s.geral.validacao.tamanhomaximo').replace('%s', 50))
          ,
          atpo_numero_serie_saida_abastek: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(50, t('s.geral.validacao.tamanhomaximo').replace('%s', 50))
          ,
        });

        await schema.validate(param, {
          abortEarly: false,
        });

        const objSend = {
          ...initials,
          ...param,
        };

        if (create) dispatch(storeData(objSend, params));
        else dispatch(updateData(objSend, params));
      } catch (err) {
        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          reference.current.setErrors(validationErrors);
        }
      }
    },
    [initials, create]
  );

  return (
    <Container>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>

          <Hidden name="atpo_codigo" label="atpo_codigo" />

          <DateTime name="atpo_data_solicitacao" label="Data solicitacao" time />

          <DateTime name="atpo_data_atendimento" label="Data atendimento" time nullable />

          <Input
            name="atpo_numero_os"
            label="Número da OS"
          />
          <Hidden
            name="poco_codigo"
            label="poco_codigo"
          />
          <Input
            name="atpo_local_atendimento"
            label="Local"
          />

          <Hidden
            name="prpo_codigo"
            label="prpo_codigo"
          />
          <Input
            name="atpo_problema"
            multiline
            rows={10}
            label='Problema:'
          />

          <Hidden
            name="sopo_codigo"
            label="sopo_codigo"
          />
          <Input
            name="atpo_solucao"
            multiline
            rows={10}
            label='Solução:'
          />

          <Input
            name="atpo_tecnico"
            label="Técnico"
          />

          <Hidden
            name="eqpo_codigo"
            label="eqpo_codigo"
          />

          <Input
            name="atpo_equipamento"
            label="Equipamento"
          />

          <Hidden
            name="capo_codigo"
            label="capo_codigo"
          />
          <Input
            name="atpo_causa"
            label="Causa"
          />

          <Input
            name="atpo_numero_serie_entrada_abastek"
            label="Nº Serie de entrada Na Abastek"
          />
          <Input
            name="atpo_numero_serie_saida_abastek"
            label="Nº Serie de Saída da Abastek"
          />


        </Form>
      )}
    </Container>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
